//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        type: {
            default: 'all'
        },
        building: ''
    },
    data: function data() {
        return {
            loading: true,
            headers: ['Name', 'Lease ID', 'Building', 'Unit', { title: 'Lease Expires', filter: 'dateFull' }, { title: 'Rent Amount', filter: 'toCurrency' }],
            fields: ['person.full_name', 'lease_id', 'person.building_id', 'unit_id', 'lease_expire_date', 'rent_amount'],
            residents: []
        };
    },

    watch: {
        building: function building(newVal, oldVal) {
            if (newVal) {
                this.residents = [];
                this.building = newVal;
                this.refreshData();
            }
        }
    },
    created: function created() {
        Event.$on('remove-resident', this.removeResident);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('remove-resident');
    },
    mounted: function mounted() {
        this.refreshData();
    },

    methods: {
        refreshData: function refreshData() {
            var $el = this;

            if ($el.building) {
                axios.get('/prototype/residents/showBuilding/' + $el.building).then(function (response) {
                    if (response.data) {
                        $el.residents = response.data;
                    }
                });
            }
        },
        removeResident: function removeResident(item) {
            Event.$emit('confirm-delete', item, '/prototype/eagles-point/delete');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/ResidentListBuilding.vue
// module id = Zm9H
// module chunks = 0 1